class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id || null;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
//88888888888888888888
/* =========================================================
   FREE GIFT AUTO ADD / REMOVE
   Threshold: ₹699
   Free Gift Variant ID: 45145144262911
   ========================================================= */

(() => {
  const FREE_GIFT_VARIANT_ID = 45145144262911;
  const FREE_GIFT_THRESHOLD = 69900; // ₹699 in paise

  let giftUpdateInProgress = false;

  // Get the current cart
  async function getCurrentCart() {
    const response = await fetch(`${routes.cart_url}.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return response.json();
  }

  // Check if the cart qualifies for the free gift
  async function checkFreeGift() {
    if (giftUpdateInProgress) return;

    try {
      const cart = await getCurrentCart();

      // Do not count the free gift in the qualifying amount
      const qualifyingItems = cart.items.filter(
        (item) => Number(item.variant_id) !== FREE_GIFT_VARIANT_ID
      );

      const qualifyingSubtotal = qualifyingItems.reduce(
        (total, item) => total + Number(item.final_line_price),
        0
      );

      const giftItem = cart.items.find(
        (item) => Number(item.variant_id) === FREE_GIFT_VARIANT_ID
      );

      const qualifiesForGift = qualifyingSubtotal >= FREE_GIFT_THRESHOLD;

      // Cart is ₹699 or more and gift is not in the cart
      if (qualifiesForGift && !giftItem) {
        await addFreeGift();
        return;
      }

      // Cart is below ₹699 and gift is already in the cart
      if (!qualifiesForGift && giftItem) {
        await removeFreeGift(giftItem);
        return;
      }

      // Keep the free gift quantity at 1
      if (qualifiesForGift && giftItem && giftItem.quantity !== 1) {
        await setGiftQuantityOne(giftItem);
      }
    } catch (error) {
      console.error('Free gift error:', error);
    }
  }

  // Add the free gift to the cart
  async function addFreeGift() {
    giftUpdateInProgress = true;

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: FREE_GIFT_VARIANT_ID,
              quantity: 1,
            },
          ],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to add free gift');
      }

      const data = await response.json();

      // Update the cart drawer
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && data.sections) {
        const drawerSection = data.sections['cart-drawer'];

        if (drawerSection) {
          const html = new DOMParser().parseFromString(
            drawerSection,
            'text/html'
          );

          const newDrawer = html.querySelector('#CartDrawer');
          const currentDrawer = document.querySelector('#CartDrawer');

          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }
      }

      // Update the cart icon
      if (data.sections && data.sections['cart-icon-bubble']) {
        const bubbleHTML = new DOMParser().parseFromString(
          data.sections['cart-icon-bubble'],
          'text/html'
        );

        const newBubble = bubbleHTML.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');

        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      }

      // Notify other cart components
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'free-gift',
          cartData: data,
          variantId: FREE_GIFT_VARIANT_ID,
        });
      }
    } catch (error) {
      console.error('Unable to add free gift:', error);
    } finally {
      giftUpdateInProgress = false;
    }
  }

  // Remove the free gift from the cart
  async function removeFreeGift(giftItem) {
    giftUpdateInProgress = true;

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to remove free gift');
      }

      const data = await response.json();

      updateCartDrawerAfterGiftChange(data);
    } catch (error) {
      console.error('Unable to remove free gift:', error);
    } finally {
      giftUpdateInProgress = false;
    }
  }

  // Keep the free gift quantity at 1
  async function setGiftQuantityOne(giftItem) {
    giftUpdateInProgress = true;

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to update gift quantity');
      }

      const data = await response.json();

      updateCartDrawerAfterGiftChange(data);
    } catch (error) {
      console.error('Unable to update free gift quantity:', error);
    } finally {
      giftUpdateInProgress = false;
    }
  }

  // Update the cart drawer after adding or removing the gift
  function updateCartDrawerAfterGiftChange(data) {
    if (!data || !data.sections) return;

    // Update the cart drawer
    if (data.sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(
        data.sections['cart-drawer'],
        'text/html'
      );

      const newDrawerInner = html.querySelector('.drawer__inner');
      const currentDrawerInner = document.querySelector(
        '#CartDrawer .drawer__inner'
      );

      if (newDrawerInner && currentDrawerInner) {
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }
    }

    // Update the cart icon
    if (data.sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(
        data.sections['cart-icon-bubble'],
        'text/html'
      );

      const newBubble = html.querySelector('#cart-icon-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }
    }

    // Notify other cart components
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'free-gift',
        cartData: data,
        variantId: FREE_GIFT_VARIANT_ID,
      });
    }
  }

  // Listen for cart changes
  function listenForCartUpdates() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // Ignore updates made by this free gift script
        if (event && event.source === 'free-gift') {
          return;
        }

        setTimeout(() => {
          checkFreeGift();
        }, 150);
      });
    }
  }

  // Start the free gift check
  function initFreeGift() {
    listenForCartUpdates();

    // Check the cart when the page loads
    setTimeout(() => {
      checkFreeGift();
    }, 300);
  }

  // Run when the page is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeGift);
  } else {
    initFreeGift();
  }
})();


//8888888888888888888888888
// cart-drawer.js
// window.openCartDrawer = () => {
//   const drawer = document.querySelector('cart-drawer');
//   if (drawer) drawer.open();
// };

// document.addEventListener('DOMContentLoaded', () => {
//   if (sessionStorage.getItem('openCartDrawer')) {
//     sessionStorage.removeItem('openCartDrawer');
//     window.openCartDrawer();
//   }
// });